import { API } from 'src/constants/api';
import { axiosInterceptor } from 'src/utils/interceptors';

export const adminList = async (payload?: any, signal?: any) => {
    const uri = API.Admin.list + payload;
    const response = await axiosInterceptor.get(uri, { signal: signal });
    return response;
};
export const adminUpdateStatus = async (payload?: any) => {
    const uri = API.Admin.updateStatus + payload;
    const response = await axiosInterceptor.get(uri);
    return response;
};

export const createAdmin = async (payload?: any) => {
    const uri = API.Admin.create;
    const response = await axiosInterceptor.post(uri, payload);
    return response;
};

export const adminTimeSpent = async (payload?: any) => {
    const uri = API.Admin.timeSpent;
    const response = await axiosInterceptor.post(uri, payload);
    return response;
};
export const adminUpdate = async (payload?: any) => {
    const uri = API.Admin.update;
    const response = await axiosInterceptor.post(uri, payload);
    return response;
};
export const adminResetPassword = async (payload?: any) => {
    const uri = API.Admin.resetPassword;
    const response = await axiosInterceptor.post(uri, payload);
    return response;
};
